// extracted by mini-css-extract-plugin
export var container = "_mz-0";
export var dotAnimation = "_mz-2";
export var dotsLoading = "_mz-1";